<ng-container *ngIf="asset && !isLoading">
  <div class="translations">
    <div class="translation">
      <mat-form-field><input [(ngModel)]="asset.title" matInput placeholder="{{'resources.title' | translate}}" (ngModelChange)="emitChange()" type="text"></mat-form-field>
      <img class="flag" src="../assets/img/languages/de.jpg">
    </div>
    <div *ngFor="let lang of selectedLanguages; let i = index" class="translation">
      <mat-form-field><input [(ngModel)]="lang.title" matInput placeholder="{{'general.languages.' + lang.language | translate}}" (ngModelChange)="emitChange()" type="text"></mat-form-field>
      <div class="disclaimer">{{'general.deeplDisclaimer' | translate}}</div>
      <mat-icon class="deeplTranslate" [matTooltip]="'dynamicContent.translateFromMain' | translate" (click)="translateTitleFromMainLanguage(lang.language, i)">translate</mat-icon>
      <img class="flag" src="../assets/img/languages/{{lang.language}}.jpg">

      <mat-icon (click)="removeTranslation(lang)" class="remove-lang">delete</mat-icon>
    </div>
  </div>
  <div class="bottom-container">
    <button class="ibexfusion-raised-button small" *ngIf="(languages?.length - 1) !== selectedLanguages?.length && languages?.length > 1"
            (click)="addLanguage()" mat-button>{{ 'dynamicContent.addTranslation' | translate }}</button>
    <smart-input (onChange)="emitChange()" *ngIf="showInFrontCheckbox" [(model)]="asset" key="displayFileDescription"
                 translationPrefix="resources"></smart-input>
  </div>
  <div class="spinner-container" *ngIf="isTranslating"><mat-spinner></mat-spinner></div>
</ng-container>
